import {
  getUserSettingsSelector,
  setUserSettings,
  setUserSettingsIsLoading,
} from './userSettingsSlice';
import {
  saveUserTheme,
  saveUserPerformanceCookiePreference,
  fetchUserSettings,
  setDoNotProcessForPendo,
  saveUserLanguage,
} from '../../services/userSettingsService';

export const loadUserSettingsThunk = () => async (dispatch) => {
  dispatch(setUserSettingsIsLoading());
  const getResponse = await fetchUserSettings();
  if (getResponse) {
    dispatch(setUserSettings(getResponse.data));
  }
};

export const changeUserThemeThunk =
  (darkMode) => async (dispatch, getState) => {
    const currentUserSettings = getUserSettingsSelector(getState());

    if (
      !currentUserSettings.loading &&
      !!currentUserSettings.settings.darkMode !== darkMode
    ) {
      dispatch(setUserSettingsIsLoading());
      try {
        await saveUserTheme(darkMode);
      } catch (e) {
        setUserSettingsIsLoading(false);
      }
      dispatch(loadUserSettingsThunk());
    }
  };

export const changeUserLanguageThunk = (languageCode) => async (dispatch) => {
  dispatch(setUserSettingsIsLoading());
  try {
    await saveUserLanguage(languageCode);
  } catch (e) {
    setUserSettingsIsLoading(false);
  }
  dispatch(loadUserSettingsThunk());
};

export const changeUserPerformanceCookiePreferenceThunk =
  (allowPerformanceCookies, doNotProcessRequests) =>
  async (dispatch, getState) => {
    const currentUserSettings = getUserSettingsSelector(getState());
    if (
      !currentUserSettings.loading &&
      !!currentUserSettings.settings.allowPerformanceCookies !==
        allowPerformanceCookies
    ) {
      dispatch(setUserSettingsIsLoading());
      await Promise.all([
        saveUserPerformanceCookiePreference(allowPerformanceCookies),
        setDoNotProcessForPendo(doNotProcessRequests),
      ]);
      dispatch(loadUserSettingsThunk());
    }
  };
